import { render, staticRenderFns } from "./MopMultiSelect.vue?vue&type=template&id=0d2da52d&"
import script from "./MopMultiSelect.vue?vue&type=script&lang=js&"
export * from "./MopMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports